import { render, staticRenderFns } from "./VideosV3Accordian.vue?vue&type=template&id=10d008a2&scoped=true"
import script from "./VideosV3Accordian.vue?vue&type=script&lang=js"
export * from "./VideosV3Accordian.vue?vue&type=script&lang=js"
import style0 from "./VideosV3Accordian.vue?vue&type=style&index=0&id=10d008a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d008a2",
  null
  
)

export default component.exports